export default "__VITE_ASSET__1079a8c3__"